import { IColorFactory } from './color-factory.interface';

const DEFAULT_BAR_COLORS = Object.freeze(['default-bar-1', 'default-bar-2', 'default-bar-3']);

export class DefaultColorFactory implements IColorFactory {
  public get(_barIndex: number, barIndexInGroup: number, _barValue: number): string {
    return DEFAULT_BAR_COLORS[barIndexInGroup];
  }
}
